module.exports = __webpack_public_path__ + "static/media/RPTU_Logo.640a66d4.png";